/** 音轨相关的错误文案 */
export var AUDIO_TRACK_ERROR_MSG;
(function (AUDIO_TRACK_ERROR_MSG) {
    AUDIO_TRACK_ERROR_MSG["KERNEL_NOT_EXISTS"] = "kernel not exists";
    AUDIO_TRACK_ERROR_MSG["NOT_SUPPORT"] = "not support";
    AUDIO_TRACK_ERROR_MSG["STATE_INVALID"] = "state invalid";
})(AUDIO_TRACK_ERROR_MSG || (AUDIO_TRACK_ERROR_MSG = {}));
